<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableSubnetResourceListData"
      style="width: 100.1%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableSubnetResourceVue = {};
export default {
  name: "TableSubnetResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      accountNameSearchIDVal: "",
      subnetSearchIDVal: "",
      columns: [
        {
          title: this.$t("RAM.AWS.Subnet.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.Subnet.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.Subnet.subnetName"),
          key: "name"
        },
        {
          title: this.$t("RAM.AWS.Subnet.subnetID"),
          key: "subnetId"
        },
        {
          title: "VPC ID",
          key: "vpcId"
        },
        {
          title: "CIDR",
          key: "cidrBlock"
        },
        {
          title: this.$t("RAM.AWS.Subnet.availabilityZone"),
          key: "availabilityZone"
        },
        {
          title: this.$t("RAM.AWS.Subnet.availableIP"),
          key: "availableIpAddressCount"
        }
      ],
      tableSubnetResourceListData: []
    };
  },
  beforeCreate: function() {
    tableSubnetResourceVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("accountNameSearchID", function(val) {
      tableSubnetResourceVue.accountNameSearchIDVal = val;
    });

    // 获取搜索内容
    eventBus.$on("subnetSearchID", function(val) {
      tableSubnetResourceVue.subnetSearchIDVal = val;
    });
    // 获取搜索内容
    eventBus.$on("companyId", function(val) {
      tableSubnetResourceVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableSubnetResourceVue.getSubnetResourceListData();
    },
    // 分页显示数据
    /****************************************************/
    getSubnetResourceListData: function() {
      var pageSubnetDate = {
        pageNum: this.current,
        pageSize: this.pageSize,
        companyId: tableSubnetResourceVue.companyId,
        subnetId: tableSubnetResourceVue.subnetSearchIDVal,
        accountName: tableSubnetResourceVue.accountNameSearchIDVal
      };

      //子网ID
      if (
        this.$route.query.type == "subnetId" &&
        pageSubnetDate.subnetId == ""
      ) {
        pageSubnetDate.subnetId = this.$route.query.subnetIds;
      }

      this.$api.resourceManagement
        .selectAWSSubnetByPage(pageSubnetDate)
        .then(res => {
          this.tableSubnetResourceListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableSubnetResourceVue.getSubnetResourceListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableSubnetResourceVue.getSubnetResourceListData();
    },
    // 销毁caseSearchID
    beforeDestroy: function() {
      eventBus.$off("accountNameSearchID");
      eventBus.$off("subnetSearchID");
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/subnet/TableSubnetResource.vue